<template>
  <div>
    <h3 class="header-title">Class</h3>
    <label>Let’s see your class progress.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <span class="float-left">
                <img
                  src="../assets/img/iconnoti.svg"
                  class="ml-5 mr-2 mb-3 mt-3"
                />
                <span class="text-white mt-3 mb-2"> | </span>
              </span>

              <span class="float-left">
                <label class="ml-2 text-white mt-3 mb-2"
                  >Please check your students attendance for today class
                  <br /><br />
                  <CButton type="btn" class="btn-bg-white"
                    >Check Now</CButton
                  ></label
                >
                <br />
              </span>
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="position: absolute; top: 0; right: 100px; bottom: 0"
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>

    <CRow class="mt-1">
      <CCol sm="9">
        <CCard>
          <CRow class="m-2">
            <CCol sm="4" class="float-left">
              <h5 class="custom-subtitle-card m-2">Schedule</h5></CCol
            >
            <CCol sm="8" class="float-right">
              <CRow class="float-right">
                <v-select :options="teachers" id="mySelect" label="Name" class="mr-2" @input="FilteredTeacher(selectedTeacher.Name)" v-model="selectedTeacher">
                  <template slot="option" slot-scope="option">
                    <img
                      v-if="option.profileImagePath == null"
                      style="border: 1px solid #eee;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                      src="../assets/img/default.png"
                      class="grey lighten-2 mt-2"
                    />

                    <img
                      v-else
                      style="
                        border: 3px solid #ddd;
                        background: #fff;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                      :src="getPic(option)"
                      class="grey lighten-2 mt-2"
                    />
                    {{ option.Name }}
                  </template>
                </v-select>

              

                <v-select
                  v-model="selectedSubject"
                  :options="subjectOptions"
                  id="mySelect"
                  label="title"
                  class="mr-2"
                  @input="FilteredSubject()"
                />
                <CButton color="primary" type="button" class="btn-blue-primary-noborder"> + Create</CButton>
              </CRow>
            </CCol>
          </CRow>

          <CRow class="p-3">
            <vue-cal
              class="vuecal--white-theme"
              :events="FilteredSubjects"
              :time-from="7 * 60"
              events-count-on-year-view="events-count-on-year-view"
              events-on-month-view="short"
              active-view="week"
            >
              <template v-slot:no-event="">No event 👌</template>
            </vue-cal>

            <!-- <SpringCalendar year="2022" default-type="week" color="#5118ac" 
          show="month" :events="FilteredTest" locale="en" start-of-week="0"/> -->

            <!-- <SpringCalendar year="2022" color="#41b883" default-type="year" :events="FilteredTest"/>

          <div id="calendar" style="height: 800px"></div> -->
          </CRow>

          <br />
          <br />
          <br />
        </CCard>

        <CCard>
          <CRow>
            <CCol sm="12">
              <div class="float-left">
                <h5 class="custom-subtitle-card m-2 ml-2">Announcement</h5>
              </div>
              <div class="float-right">
                <div class="text-right">
                  <img src="../assets/img/editicon.svg" />
                </div>
              </div>

              <br /><br />
              <div v-for="item in announcement" v-bind:key="item.Id">
                <label class="small text-muted ml-2">
                  {{ item.dataMessage }}
                  <br />
                  {{ item.name }} |
                  {{ item.createdTime | moment("MMM DD YYYY hh:mm") }}
                </label>
              </div>
              <label class="custom-16px ml-2 mt-4"><b>View All</b></label>
            </CCol>
          </CRow>
        </CCard>
      </CCol>
      <CCol sm="3">
        <CCard>
          <div class="custom-height-card">
            <h5 class="custom-subtitle-card m-2">Today Classes</h5>
            <div
              v-for="item in schedule.slice(0, 4)"
              v-bind:key="item.Id"
              class="p-2"
            >
              <h5 class="custom-24px">{{ item.SubjectName }}</h5>
              <h6>
                {{ item.StartDate | moment("HH:mm") }} -
                {{ item.End | moment("HH:mm") }}
              </h6>
              <h6>{{ item.Teacher }}</h6>
            </div>
          </div>
          <label class="custom-16px ml-2 mt-4" @click="GoToAttendance()"
            ><b>Take Attendance</b></label
          >
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";


Vue.use(require("vue-moment"));
import moment from "moment";

Vue.use(FullCalendar);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    VueCal,
  },
  data() {
    return {
      user: {},
      schedule: [],
      scheduler: [],

      FilteredSubjects: [],
      announcement: [],

      selectedSubject: "SELECT SUBJECT",
      subjectOptions: [],

      selectedTeacher: "SELECT TEACHER",
      teacherOptions: [],

      teachers: [],
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetScheduleStudent();
      this.GetAnnouncement();
      this.GetSchedule();
      this.GetTeacher();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;

            this.GetScheduleStudent();
            this.GetAnnouncement();
            this.GetSchedule();
            this.GetTeacher();
          }
        });
    },
    GetScheduleStudent() {
      this.$API
        .get(this.$ViewSchedule, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.scheduler = response.data;

            this.FilteredSubjects = this.scheduler;

            // var scheduleNames = _.uniq(_.map(response.data, "title"));
            // scheduleNames.sort(function (a, b) {
            //   return a.toLowerCase().localeCompare(b.toLowerCase());
            // });
            // this.subjectOptions = scheduleNames;
            // this.subjectOptions.unshift("SELECT SUBJECT");

            // var teacherNames = _.uniq(_.map(response.data, "Teacher"));
            // teacherNames.sort(function (a, b) {
            //   return a.toLowerCase().localeCompare(b.toLowerCase());
            // });
            // this.teacherOptions = teacherNames;
            // this.teacherOptions.unshift("SELECT TEACHER");

            var combinedrates = [];
            for (let i in this.FilteredSubjects) {
              let item = this.FilteredSubjects[i];

              combinedrates.push({
                start: item.start,
                end: item.end,
                class: item.ThemeColor,
                title: item.title + "-" + item.Teacher,
                scheduleId: item.ScheduleId,
              });
            }

            this.FilteredSubjects = combinedrates;
          }
        });
    },
    GetSchedule() {
      this.Busy = true;
      this.$API
        .get(this.$ScheduleStudentWebAll, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
          }
        });
    },
    GetTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data;
            this.getPic(this.teachers);
          }
        });
    },
    getPic(option) {
      return "https://pickiddo.com" + option.profileImagePath;
    },
    GetAnnouncement() {
      this.$API
        .get(this.$AllNotificationLimitAuthorizeByWebTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.announcement = response.data;
          }
        });
    },
    onEventClick(event, e) {
      this.selectedEvent = event;
      this.scheduleId = event.scheduleId;
      this.date = moment(event.start).format("YYYY-MM-DD");

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + this.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
          } else {
            console.log(this.info.detail);
          }
        });

      this.$API
        .get(this.$ViewScheduleByDate + "?start=" + this.date, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.schedules = response.data;
          }
        });

      this.showDialog = true;

      // Prevent navigating to narrower view (default vue-cal behavior).
      e.stopPropagation();
    },
    RefreshData() {
      this.GetScheduleStudent();
      this.selectedSubject = "";
      this.selectedTeacher = "";
    },

    FilteredSubject(event, e) {
      this.FilteredSubjects = this.scheduler;
      var combinedrates = [];
      for (let i in this.FilteredSubjects) {
        let item = this.FilteredSubjects[i];

        combinedrates.push({
          start: item.start,
          end: item.end,
          title: item.title,
          class: item.ThemeColor,
          Teacher: item.Teacher,
          scheduleId: item.ScheduleId,
        });
      }

      this.FilteredSubjects = combinedrates;

      this.FilteredSubjects = _.filter(
        this.FilteredSubjects,
        (item) => item.title === this.selectedSubject
      );
    },

    FilteredTeacher(event, e,Name) {
      this.FilteredSubjects = this.schedule;
     var combinedrates = [];
      for (let i in this.FilteredSubjects) {
        let item = this.FilteredSubjects[i];

        combinedrates.push({
          start: item.start,
          end: item.end,
          title: item.title + "-" + item.Teacher,
          class: item.ThemeColor,
          Teacher: item.Teacher,
          scheduleId: item.ScheduleId,
        });
      }

      this.FilteredSubjects = combinedrates;

      this.FilteredSubjects = _.filter(
        this.FilteredSubjects,
        (item) => item.Teacher == Name
      );

      // this.$API
      //   .get(this.$EditSchedule + "?scheduleID=" + item.scheduleId, {
      //     withCredentials: true,
      //   })
      //   .then((response) => {
      //     this.info = response.data;
      //     console.log(this.info);

      //     if (response.status == 200 && this.info != null) {
      //       this.ClassName = this.info.ClassName;
      //       this.SubjectName = this.info.SubjectName;
      //       this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
      //       this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

      //       this.TuitionSubjectID = this.info.TuitionSubjectID;
      //       console.log("testing" + this.SelectedScheduleDateTime);
      //     } else {
      //       console.log(this.info.detail);
      //     }
      //   });
    },
    GoToAttendance() {
      this.$router.push("LearningAttendance");
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-app {
  font-family: montserrat, Sans-serif;
}

.v-select {
    min-width: 200px;
    background: #F9F9F9;
border-radius: 8px;
border: none;
border-style: none; 
}

#mySelect .v-select .dropdown-toggle {
   border: none;
   border-style: none; 
}
</style>